export default () => ({
  translations: [],
  serviceElementTranslations: [],
  languages: [],
  customMessageTranslations: []
})



// WEBPACK FOOTER //
// ./src/store/modules/translation/state.js